import * as stylex from '@stylexjs/stylex';
import { faInfoCircle } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';
import type { ReactNode } from 'react';

interface KpiLabelWithDescriptionProps {
  label: ReactNode;
  description?: string | null;
  stopIconPropagation?: boolean;
}

export function KpiLabelWithDescription({
  label,
  description,
  stopIconPropagation = false,
}: KpiLabelWithDescriptionProps) {
  if (!description) {
    return <>{label}</>;
  }

  return (
    <span>
      {label}
      <Icon
        icon={faInfoCircle}
        tooltip={description}
        xstyle={styles.descriptionIcon}
        onClick={stopIconPropagation ? (event) => event?.stopPropagation() : undefined}
      />
    </span>
  );
}

const styles = stylex.create({
  descriptionIcon: { marginLeft: 5 },
});
